export default {"src":"/_next/static/media/crossline.78bb8179.svg","height":45,"width":238,"blurWidth":0,"blurHeight":0};